<template>
  <Tooltip>
    <template #element>
      <span>
        Hilfe bei der Umsetzung
      </span>
      <InformationCircleIcon class="info-icon" />
    </template>
    <template #content>
      <span>
        Einschätzung, ob die Methode selber oder mit Hilfe anderer umgesetzt werden kann.
      </span>
    </template>
  </Tooltip>
</template>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
